import "./AddAssignmentsButton.styles.scss";
import React from "react";
import { Button } from "components";
import Plus from "assets/icons/circle-plus.svg";

type AddAssignmentsButtonProps = {
  onClick: () => void;
};

const AddAssignmentsButton = ({ onClick }: AddAssignmentsButtonProps) => {
  return (
    <Button
      name="add_assignment_button"
      value="Add Assignment"
      pill
      icon={Plus}
      size="small"
      onClick={onClick}
    />
  );
};

export default AddAssignmentsButton;
